import { createAction } from '@reduxjs/toolkit'

export const setPrice = createAction<{ tokenId: string; price: number }>('tokenPrice/setPrice')
export const setPrices = createAction<{ tokenIds: string[]; prices: number[] }>('tokenPrice/setPrices')
export const setLoading = createAction<{ tokenId: string; loading: boolean }>('tokenPrice/setLoading')
export const setLoadingMultiple = createAction<{ tokenIds: string[]; loading: boolean }>(
  'tokenPrice/setLoadingMultiple'
)
